import './runtimePublicEnv';
import { clientEnv } from './buildTimeEnv';
import { SPORTSTV_COMPANY_ID, SPORTSTV_API_BASE, SPORTSTV_MEDIA_CDN } from './config/brandConfig';

// Sports.TV backend identity. API base + company id are non-secret defaults (brandConfig.js);
// the DSP API key is injected via .env / window.__DSP_API_KEY__ (see runtimePublicEnv.js), not committed.
window.API_BASE_URL = window.API_BASE_URL ||
  clientEnv.REACT_APP_SPOTLIGHT_API_URL || SPORTSTV_API_BASE;
window.COMPANY_ID = window.COMPANY_ID ||
  clientEnv.REACT_APP_COMPANY_ID || SPORTSTV_COMPANY_ID;
window.CONTENT_BASE_URL = window.CONTENT_BASE_URL ||
  clientEnv.REACT_APP_CONTENT_BASE_URL || SPORTSTV_MEDIA_CDN;
window.IMAGES_BASE_URL = window.IMAGES_BASE_URL ||
  clientEnv.REACT_APP_IMAGES_BASE_URL || `${SPORTSTV_MEDIA_CDN}/images`;
window.EMBEDDED_JWT = window.EMBEDDED_JWT ||
  (typeof window !== 'undefined' && window.__SPOTLIGHT_EMBEDDED_JWT__) ||
  process.env.REACT_APP_SPOTLIGHT_API_TOKEN;

if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Development mode: API_BASE_URL set to:', window.API_BASE_URL);
  console.log('🔧 Development mode: COMPANY_ID set to:', window.COMPANY_ID);
  console.log('🔧 Development mode: CONTENT_BASE_URL set to:', window.CONTENT_BASE_URL);
  console.log('🔧 Development mode: IMAGES_BASE_URL set to:', window.IMAGES_BASE_URL);
  console.log(
    '🔧 Development mode: EMBEDDED_JWT set to:',
    window.EMBEDDED_JWT ? '[REDACTED]' : 'undefined',
  );
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { tokenService } from './services/auth/TokenService';
import { enhancedOnRedirectCallback } from './utils/AuthUrlCleanup';
import { loadOneTrust } from './consent/loadOneTrust';

// Initialize TokenService with embedded JWT
tokenService.initializeWithEmbeddedJWT();

// Load the OneTrust CMP SDK when REACT_APP_CMP=onetrust (no-op otherwise).
loadOneTrust();

const onRedirectCallback = enhancedOnRedirectCallback;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={clientEnv.REACT_APP_AUTH0_DOMAIN}
    clientId={clientEnv.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: 'openid profile email',
    }}
    onRedirectCallback={onRedirectCallback}
    useRefreshTokens={true}
    cacheLocation="localstorage"
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Auth0Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
